<template>
    <div class="password-reset-form" v-if="tokenValid">
        <h1>{{$t('passwordReset.title')}}</h1>
        <Message :message="error.msg" type="error" v-for="error in errors.items"></Message>
        <div class="login">
            <div class="inputs">
                <input :placeholder="$t('passwordReset.newPassword')" name="password" ref="password"
                       required
                       type="password" v-model="password" v-validate="'required|min:8'"/>
                <input :placeholder="$t('passwordReset.repeatPassword')"
                       data-vv-as="password"
                       data-vv-rules="confirmed:password"
                       name="password_confirmation"
                       required
                       type="password"
                       v-model="passwordRepeat"
                       v-validate="'required|confirmed:password'"
                />
            </div>

            <div class="buttons">
                <button @click="resetPassword" class="login-button" type="submit">{{$t('passwordReset.submit')}}
                </button>
                <router-link :to="{name: 'forgot-password'}"></router-link>
            </div>
        </div>
    </div>
    <div class="change-confirmation" v-else-if="!tokenValid && passwordSend">
        <Message :message="message" :type="type" v-if="resetComplete">
        </Message>
        <Preloader></Preloader>
    </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Message from '@/components/helpers/Message';
import Preloader from '@/components/helpers/Preloader';

const UserRepository = RepositoryFactory.get('users');
export default {
  components: { Preloader, Message },
  data() {
    return {
      password: '',
      passwordRepeat: '',
      tokenValid: false,
      passwordSend: false,
      token: '',
      message: '',
      type: 'info',
      resetComplete: false,
    };
  },
  name: 'PasswordResetStep2',
  mounted() {
    this.$validator.localize(this.$i18n.locale, {
      messages: {
        required: field => this.$t('validation.requiredFields'),
        confirmed: field => this.$t('validation.passwordMatch'),
        min: field => this.$t('validation.passwordLength'),
        email: field => this.$t('validation.login'),
      },
    });
    localStorage.removeItem('token');
    const { token } = this.$route.query;

    UserRepository.passwordResetCheck(token)
      .then((response) => {
        this.tokenValid = true;
        this.token = token;
      }).catch((error) => {
        this.$router.push({ path: '/login' });
      });
  },
  methods: {
    async resetPassword() {
      await this.$validator.validateAll();
      if (this.errors.items.length <= 0) {
        this.passwordSend = true;
        this.tokenValid = false;
        UserRepository.passwordResetSetNewPassword({ token: this.token, password: this.password })
          .then((response) => {
            this.message = this.$t('passwordReset.success');
            this.resetComplete = true;
            this.$router.push({ path: '/login' });
            return response;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    .password-reset-form, .change-confirmation {
        width: 500px;
        margin: 200px auto;
        @include media('<540px') {
            width: 90%;
        }

        h1 {
            font-size: rem(30px);
            font-weight: bold;
            // color: $baseTextColor;
            margin-bottom: 20px;
            text-align: left;

        }

        .login {

            .inputs {
                display: flex;
                flex-direction: column;

                input {
                    margin: 20px 0;
                    border: 1px solid $border-gray;
                    border-radius: 5px;
                    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.16);
                    font-size: rem(14px);
                    padding: 14px 0 14px 30px;
                }
            }

            .buttons {
                display: flex;
                justify-content: space-between;
                margin-top: 40px;
                align-items: center;
                @include media('<400px') {
                    flex-direction: column;
                    margin-top: 20px;
                }

                a {
                    text-decoration: none;
                    color: $peacock-blue;
                    @include media('<400px') {
                        flex-direction: column;
                        margin-top: 20px;
                    }
                }

                button {
                    color: white;
                    font-weight: bold;
                    font-size: rem(18px);
                    background-color: $peacock-blue;
                    padding: 12px 50px;
                    border-radius: 30px;
                    border: 1px solid $peacock-blue;
                    transition: 300ms all ease-in;
                    cursor: pointer;

                    &:hover {
                        color: $peacock-blue;
                        background-color: white;
                    }
                }
            }
        }
    }

</style>
